import * as React from "react";
import {VeBoxModal} from "../../../components/modal/VeBoxModal";
import {ValidatedEquipmentModalElement, ValidatedEquipmentModalElementProps} from "./ValidatedEquipmentModalElement";
import {Display} from "../../../components/Display";

interface ValidatedEquipmentInfoModalProps {
    onClose: () => void
    title: string;
    description?: string;
    statusElements: ValidatedEquipmentModalElementProps[]
}

export const ValidatedEquipmentInfoModal: React.FC<ValidatedEquipmentInfoModalProps> = ({
                                                                                            onClose,
                                                                                            title,
                                                                                            description,
                                                                                            statusElements
                                                                                        }) => {
    return (
        <VeBoxModal.Backdrop>
            <VeBoxModal style={{width: 500}}>
                <VeBoxModal.Header title={title} onClose={onClose}/>
                <VeBoxModal.Section style={{padding: 20}}>
                    <div className={"legend-item-states-container"}>
                        <Display isVisible={description?.length > 0}>
                            <p className={"description"}>{description}</p>
                        </Display>
                        <div className={"legend-items-section"}>
                            {statusElements.map(
                                (status, index) => <ValidatedEquipmentModalElement key={index} {...status}/>)}
                        </div>
                    </div>
                </VeBoxModal.Section>
            </VeBoxModal>
        </VeBoxModal.Backdrop>
    )
}